import { css } from '@emotion/core';

export const isHtmlNode = (type: any) => {
  return typeof type === 'string';
};

const blockNodes = new Set([
  'address',
  'article',
  'aside',
  'blockquote',
  'details',
  'dialog',
  'dd',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'li',
  'main',
  'nav',
  'ol',
  'p',
  'pre',
  'section',
  'table',
  'ul',
]);

export const isBlockNode = (type: any) => {
  return blockNodes.has(type);
};

const svgNodes = new Set([
  'path',
  'rect',
  'ellipse',
  'circle',
  'g',
  'defs',
  'clipPath',
  'linearGradient',
  'stop',
  'animate',
]);

export const isSvgNode = (type: any) => {
  return svgNodes.has(type);
};

const clickableNodes = new Set(['a', 'label', 'button']);

export const isClickableNode = (type: any) => {
  return clickableNodes.has(type);
};

export const buildResetStyles = (nodeType: any) => {
  return css`
    all: unset;
    box-sizing: border-box;
    // Fix Safari 13 issue with 'color' and 'all: unset' (https://bugs.webkit.org/show_bug.cgi?id=158782).
    -webkit-text-fill-color: currentColor;
    ${nodeType === 'strong' ? 'font-weight: bold;' : ''}
    ${nodeType === 'em' ? 'font-style: italic;' : ''}
    ${isBlockNode(nodeType) ? 'display: block;' : ''}
    ${isClickableNode(nodeType) ? `cursor: pointer;` : ''}
  `;
};
